module.exports = __webpack_public_path__ + "img/logo.c6d4bfd9.png";